export default __webpack_public_path__ + "static/media/w.e6d235d6.svg";